import { z } from 'zod';
import { Permissions } from '../permissions';

export const UserConfigSchema = z.object({
  permissions: z.array(Permissions.exclude([Permissions.enum.DEFAULT])),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
});

export type UserConfigType = z.infer<typeof UserConfigSchema>;

export const UserContextGetResponseSchema = z
  .object({
    user: UserConfigSchema,
  });

export type UserContextGetResponseType = z.infer<typeof UserContextGetResponseSchema>;
